// extracted by mini-css-extract-plugin
export var arrow = "Button-module--arrow--2d283";
export var arrowNo = "Button-module--arrow_no--7cf07";
export var arrowYes = "Button-module--arrow_yes--18b8b";
export var button = "Button-module--button--54815";
export var disabled = "Button-module--disabled--d9a9c";
export var flex = "Button-module--flex--293a9";
export var flex1 = "Button-module--flex_1--aaa95";
export var flexCenter = "Button-module--flex_center--ff4cd";
export var flexCenterCol = "Button-module--flex_center_col--9080c";
export var flexCol = "Button-module--flex_col--d6712";
export var flexFixCenterCol = "Button-module--flex_fix_center_col--5501c";
export var flexFixedCenterCol = "Button-module--flex_fixed_center_col--f4117";
export var gray = "Button-module--gray--47ce7";
export var large = "Button-module--large--e93c2";
export var medium = "Button-module--medium--faca2";
export var red = "Button-module--red--6fcde";
export var rotating = "Button-module--rotating--3c288";
export var small = "Button-module--small--d0d2f";
export var white = "Button-module--white--601a8";
export var xsmall = "Button-module--xsmall--17877";